import React, { useRef } from 'react';
import { useState } from 'react';
// @ts-ignore
import styles from './CalendarTermPicker.module.scss';
import Modal from '../Modal/Modal';
import Calendar from './Calendar';
import TextField from '../Base/TextField/TextField';
import { useAppContext } from '../../Services/AppContext';
// @ts-ignore
import moment from 'moment';

interface ICalendarTermPicker {
	inputLabel?: string;
	inputPlaceholder?: string;
	htmlId?: string;
}

export default function CalendarTermPicker(props: ICalendarTermPicker) {
	const { inputPlaceholder, inputLabel, htmlId } = props;
	const [dateFrom, setDateFrom] = useState(null);
	const [dateTo, setDateTo] = useState(null);
	const [modalOpened, setModalOpened] = useState(false);
	const { translation } = useAppContext();

	const handleOnClick = () => {
		setModalOpened(true);
	};

	const handlePickDate = date => {
		setDateFrom(date);
		setModalOpened(false);
	};

	return (
		<div className={styles.wrapper}>
			<div className={'d-flex flex-row'}>
				<TextField
					id={htmlId}
					label={'Datum'}
					onClick={handleOnClick}
					placeholder={inputPlaceholder}
					value={dateFrom && moment(dateFrom.dateStr).format('DD.MM.YYYY')}
					className={styles.input}
				/>
				<TextField
					label={'Čas od'}
					onClick={handleOnClick}
					value={dateFrom && moment(dateFrom.dateStr).format('HH:mm')}
					className={styles.input}
				/>
				<TextField
					label={'Čas do'}
					value={dateTo && moment(dateTo.dateStr).format('HH:mm')}
					className={styles.input}
				/>
			</div>
			<Modal
				opened={modalOpened}
				onClose={() => setModalOpened(false)}
				fullScreen={true}>
				<Modal.Header
					title={translation['component.caseCreate.chooseADateAndTime']}
				/>
				<Modal.Content>
					<Calendar onTimeClick={handlePickDate} />
				</Modal.Content>
			</Modal>
		</div>
	);
}
